import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/// <reference types="knockout" />
/**
 * Asisia
 */
const factory = function factory({ document, thn }) {
    let refreshPrice = null;
    let refreshPage = null;
    const roomDetailsParseData = () => {
        const roomsArray = Array.from(document.querySelectorAll('.list-group-item, .room-box')).filter(room => thn.isVisible(room) && !room.querySelector('.fa-frown'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray
            .map((room) => {
            const roomName = room.querySelector('.list-group-item-heading, .room-header h3')?.textContent || '';
            const roomType = getRoomType(roomName);
            const discountPrice = thn.parseNumber(room.querySelector('.new-price, .price-details strong')?.textContent);
            const noDiscountPrice = thn.parseNumber(room.querySelector('.old-price del, .old-price')?.textContent);
            const ratePrice = discountPrice || noDiscountPrice;
            const guestsSel = room.querySelector('.prices-header small')?.textContent?.match(/\d+/g)?.map(Number) || [];
            const adults = thn.parseNumber(document.querySelector('select[data-bind*=adults]')?.value) || guestsSel?.[0];
            const children = thn.parseNumber(document.querySelector('select[data-bind*=childs]')?.value) || guestsSel?.length > 2 ? guestsSel?.[1] : 0;
            const hasBreakfast = false;
            const isRefundable = true;
            if (!roomName || !ratePrice) {
                return null;
            }
            const rateData = {
                name: '',
                totalNight: ratePrice,
                breakfast: hasBreakfast,
                refundable: isRefundable,
            };
            const roomData = {
                name: roomName,
                adults: adults || 2,
                children: children || 0,
                type: roomType,
                prices: [rateData],
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        boot() {
            refreshPage = thn.debounce(() => { thn.pageCheck(); }, 800);
            thn.bus.on('dataLayer:event.gtm.load', refreshPage);
            thn.bus.on('dataLayer:event.checkout', refreshPage);
            thn.pageUnload(() => {
                if (refreshPage) {
                    thn.bus.detach('dataLayer:event.gtm.load', refreshPage);
                    thn.bus.detach('dataLayer:event.checkout', refreshPage);
                }
            });
        },
        isUserLogged() {
            const isLogged = false;
            return isLogged;
        },
        languageCheck(ctx) {
            return new Promise((resolve, reject) => {
                const langElement = document.querySelector('.quick-menu li:nth-child(3) .active a');
                const lang = langElement?.href?.slice(-2);
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        priceObserveDom(ctx) {
            const resultContainer = document.querySelector('.rooms, .container .row');
            if (resultContainer && !refreshPrice) {
                refreshPrice = thn.debounce(() => {
                    ctx.widget.refresh().catch(() => { });
                }, 800, { maxWait: 1000 });
                thn.observeDom(resultContainer, refreshPrice, {
                    childList: true,
                    attributes: true,
                    subtree: false,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(resultContainer, refreshPrice);
                        refreshPrice = null;
                    }
                });
                const currencyContainerTopBar = document.querySelector('.currency') || document.querySelector('#curcodes button');
                if (currencyContainerTopBar) {
                    const changePriceListener = () => {
                        ctx.widget.refresh().catch(() => { });
                    };
                    currencyContainerTopBar.addEventListener('click', changePriceListener);
                    thn.pageUnload(() => {
                        currencyContainerTopBar.removeEventListener('click', changePriceListener);
                    });
                }
                const currencyContainer = document.querySelector('#curcodes');
                if (currencyContainer) {
                    const changePriceListener = () => {
                        ctx.widget.refresh().catch(() => { });
                    };
                    currencyContainer.addEventListener('click', changePriceListener);
                    thn.pageUnload(() => {
                        currencyContainer.removeEventListener('click', changePriceListener);
                    });
                }
            }
        },
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = !!url.hostname.match(/corendonhotels|gloria|/) && (!!url.search.toLowerCase().match(/checkin/) || !!url.pathname.match(/booking/));
            // https://grandparklara.corendonhotels.com/?Checkin=2024-11-06&Checkout=2024-11-07&Adult=2&RoomCount=1&language=de&Child=2&ChildAges=5%207
            // https://www.gloria.com.tr/en/booking/?Hotel=Gloria-Verde-Resort&CheckIn=2025-05-27&CheckOut=2025-05-29&RoomCount=1&Rooms[0].Adult=2&Rooms[0].Child=2&Rooms[0].Ages[0]=3&Rooms[0].Ages[1]=7&AdditionalDiscountCode=
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            Array.from(url.searchParams.keys())
                .filter(param => param.includes('Rooms['))
                .forEach(param => url.searchParams.delete(param));
            if (url.pathname.match(/booking/)) {
                url.searchParams.set('RoomCount', '[rooms]');
                url.pathname = url.pathname.replace(/\/\w{2}\//, '/[language]/');
                ctx.data.roomsDispo?.forEach((room, index) => {
                    url.searchParams.set(`Rooms[${index}].Adult`, room.adults.toString());
                    url.searchParams.set(`Rooms[${index}].Child`, room.children ? room.children.toString() : '');
                    room.childrenAges?.forEach((age, ageIndex) => {
                        url.searchParams.set(`Rooms[${index}].Ages[${ageIndex}]`, age.toString());
                    });
                });
            }
            else {
                url.searchParams.set('language', '[language]');
                if (ctx.data.roomsDispo) {
                    url.searchParams.set('Adult', ctx.data.roomsDispo[0].adults.toString());
                    url.searchParams.set('Child', ctx.data.roomsDispo[0].children ? ctx.data.roomsDispo[0].children.toString() : '');
                    url.searchParams.set('ChildAges', ctx.data.roomsDispo[0].childrenAges ? ctx.data.roomsDispo[0].childrenAges.join(' ') : '');
                }
            }
            url.searchParams.set('CheckIn', '[date_begin]');
            url.searchParams.set('CheckOut', '[date_end]');
            ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceParseData_v1() {
            // Guests, Adults & Children
            const roomNum = thn.parseNumber(document.querySelector('h2')?.textContent) || 1;
            const adults = thn.parseNumber(document.querySelectorAll('form select[data-bind*="adults"]')[roomNum - 1]?.value);
            const children = thn.parseNumber(document.querySelectorAll('form select[data-bind*=childs]')[roomNum - 1]?.value);
            const numRoomsChildrenAges = Array.from(document.querySelectorAll('.update-search h4')).map((numRoom) => thn.parseNumber(numRoom.textContent));
            const roomsDispo = [];
            const roomInfo = {
                adults: adults || 1,
                children: children || 0,
                childrenAges: [],
            };
            for (let i = 0; i < numRoomsChildrenAges.length; i += 1) {
                if (numRoomsChildrenAges[i] === roomNum) {
                    roomInfo.childrenAges = Array.from(document.querySelectorAll('form select[data-bind*=childAges]'))
                        .map((age) => (thn.parseNumber(age?.value) === 0 ? 1 : thn.parseNumber(age?.value)))
                        .filter((value) => typeof value !== 'undefined');
                    break;
                }
            }
            roomsDispo.push(roomInfo);
            // Dates
            const dateBegin = document.querySelector('input#d1')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1') ?? '';
            const dateEnd = document.querySelector('input#d2')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1') ?? '';
            const nights = thn.daysBetween(dateBegin, dateEnd);
            if (!dateBegin || !dateEnd) {
                return null;
            }
            // Prices & Currency || No Rooms
            const availableRooms = Array.from(document.querySelectorAll('.room_lists'));
            const noAvailability = document.querySelector('.list-group div')?.textContent?.match(/Unfortunately|bulunmamaktadır|Leider|К сожалению/) || thn.isVisible(document.querySelector('.availDesc'));
            const loader = document.querySelector('.fa-refresh.fa-spin');
            const pricesEl = document.querySelectorAll('.room_lists .new-price');
            const prices = Array.from(pricesEl).map((price) => thn.parseNumber(price?.textContent)).filter((value) => typeof value !== 'undefined');
            const minPrice = Math.min(...prices);
            const currency = thn.parseCurrency(document.querySelector('.new-price')?.textContent);
            if (!thn.empty(availableRooms) && currency && !thn.isVisible(loader) && !noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo,
                    price: minPrice / nights,
                    currency,
                    roomDetails: roomDetailsParseData(),
                };
            }
            if (noAvailability) {
                return {
                    roomsDispo,
                    currency,
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        priceParseData_v2() {
            const dateBegin = thn.parseUrlParameter('CheckIn')?.replace(/-/g, '/');
            const dateEnd = thn.parseUrlParameter('CheckOut')?.replace(/-/g, '/');
            const knockoutJs = window.ko;
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd);
            const activeRoom = document.querySelector('[data-bind*="activeRoom"]');
            if (!activeRoom || !knockoutJs) {
                return null;
            }
            const activeRoomData = knockoutJs.dataFor(activeRoom);
            const childrenAges = activeRoomData?.[0]?.search?.Ages?.split(' ')
                .map((age) => (thn.parseNumber(age) === 0 ? 1 : thn.parseNumber(age)))
                .filter((value) => value !== null && typeof value !== 'undefined') || [];
            const roomsDispo = [{
                    adults: activeRoomData?.[0]?.search?.Adult || 2,
                    children: childrenAges.length,
                    childrenAges,
                }];
            // Prices & Currency || No Rooms
            const availableRooms = Array.from(document.querySelectorAll('.room_lists, .room-box')).filter((room) => !room.querySelector('.fa-frown'));
            const noAvailability = document.querySelector('.list-group div')?.textContent?.match(/Unfortunately|bulunmamaktadır|Leider|К сожалению/) || thn.isVisible(document.querySelector('.availDesc')) || thn.empty(availableRooms);
            const loader = document.querySelector('.fa-refresh.fa-spin');
            const pricesEl = document.querySelectorAll('.room_lists .new-price, .price-details strong');
            const prices = Array.from(pricesEl)
                .map((price) => thn.parseNumber(price?.textContent))
                .filter((value) => value !== null && typeof value !== 'undefined');
            const minPrice = prices.reduce((min, price) => Math.min(min, price), Infinity) || undefined;
            const currency = thn.parseCurrency(document.querySelector('.new-price, .price-details strong')?.textContent);
            if (!thn.empty(availableRooms) && currency && !thn.isVisible(loader) && !noAvailability && minPrice) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo,
                    price: minPrice / nights,
                    currency,
                    roomDetails: roomDetailsParseData(),
                };
            }
            if (noAvailability) {
                return {
                    roomsDispo,
                    currency,
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const bookingId = document.querySelector('.term-description dd, [data-bind*=reservationNumbers]')?.textContent?.split(',')[0];
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            const priceText = document.querySelector('.card-information .form-group div:nth-child(2) div:nth-child(2), .basket-price-summary div>div:nth-child(2) strong')?.textContent;
            const datesArrayElms = Array.from(document.querySelectorAll('.date-time')) || [];
            const dateBeginText = datesArrayElms?.[0]?.textContent || '';
            const dateEndText = datesArrayElms?.[1]?.textContent || '';
            const dateBegin = translateDate(dateBeginText, thn.data.language);
            const dateEnd = translateDate(dateEndText, thn.data.language);
            const price = thn.parseNumber(priceText);
            const currency = thn.parseCurrency(priceText);
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
            };
        },
    };
};

export { factory };
